/*
  PLEASE DON'T EDIT THIS FILE.
  IF YOU NEED TO OVERRIDE IT,
  DO IT IN THE COMPONENT.
*/

import { useState } from 'react'

const useGridSelection = filterButtonsInitialValue => {
  const [selectedRowsData, setSelectedRowsData] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedItemKeys, setSelectedItemKeys] = useState([filterButtonsInitialValue])

  const onSelectionChanged = (data, showCheckBoxesMode) => {
    if (showCheckBoxesMode === 'always') {
      setSelectedRowKeys(data.selectedRowKeys)
      setSelectedRowsData(data.selectedRowsData.map(obj => obj.name))
    }
    // Rest of the code...
  }

  return {
    selectedRowsData,
    selectedRowKeys,
    selectedItemKeys,
    setSelectedItemKeys,
    onSelectionChanged
  }
}

export default useGridSelection
